import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/apiClient";
const BrandingContext = createContext({});
export const useBranding = () => useContext(BrandingContext);
export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState({});
  useEffect(() => { let cancelled = false; api.get("/public/branding").then(({ data }) => { if (!cancelled) setBranding(data); }).catch(() => {}); return () => { cancelled = true; }; }, []);
  useEffect(() => { if (branding.display_name) document.title = branding.display_name; }, [branding]);
  return <BrandingContext.Provider value={branding}>{children}</BrandingContext.Provider>;
}
